import { useApi }                           from '../utils/api'
import {
    useCallback, useContext,
    useEffect, useState
}                                           from 'react'
import { AppContext }                       from '../App'
import { User }                             from '../Consts'

let categories
export default function useCategories () {
    const api = useApi()
    const [local, setLocal] = useState(categories)
    const [reload, setReload] = useState(0)
    const { user } = useContext(AppContext)

    const reloadFnc = useCallback(() => {
        categories = undefined
        setReload(reload => reload + 1)
    }, [])

    useEffect(() => {
        async function load () {
            categories = (await api.category.list()).data
            setLocal(categories)
        }

        if (categories === undefined) {
            load()
        }
    }, [reload, user])

    return [local, reloadFnc]
}